import { type FunctionalComponent, h} from '@stencil/core';
import {DashboardGenericTile} from '../dashboard-generic-tile/dashboard-generic-tile';
import type { IDashboardTile } from '../../types/subcomponents-types.type';

export const DashboardPrivateTile: FunctionalComponent<IDashboardTile> = (props) => {
    const { labelProvider, doc, title, customValueClass, targetTab, tabCount, strategies, mobileView, showPlaceholder, section, privateCard, term, rtl } = props;
    return (
      doc && doc.length > 0 && (
        <DashboardGenericTile
          labelProvider={(e, f) => labelProvider(e, f)}
          title={title}
          customValueClass={customValueClass}
          targetTab={targetTab}
          tabCount={tabCount}
          mobileView={mobileView}
          subTitle={true}
          privateCard={privateCard}
          itemCount={doc.length}
          term={term}
          rtl={rtl}
        >
          <div class="private__container">
            {doc.map((el, index) => {
                return (
                  (<div
                    class={`private-dashboard-item${props.limitResults ? '-inline' : ''}`}>
                    {privateCard ?
                      <dashboard-private-item
                        labelProvider={(e, f) => labelProvider(e, f)}
                        doc={el}
                        index={index}
                        strategies={strategies}
                        section={section}
                        showPlaceholder={showPlaceholder}
                        rtl={rtl}
                      />
                      :
                      <dashboard-document-item
                        labelProvider={(e, f) => labelProvider(e, f)}
                        doc={el}
                        index={index}
                        strategies={strategies}
                        section={section}
                        showPlaceholder={showPlaceholder}
                        rtl={rtl}
                      />
                    }
                  </div>)
                );
            })}
          </div>
        </DashboardGenericTile>
      )
    );
};
